import { render } from "./promotion-index.vue?vue&type=template&id=1b89cf75"
import script from "./promotion-index.vue?vue&type=script&lang=js"
export * from "./promotion-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__